import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAppContext } from './context/AppContext';

import axios from 'axios';



const Verify = () => {
  const [formData, setFormData] = useState({
    email: '',
    otp: '',
    user:""
  });
  const [errors, setErrors] = useState({});
   const [error, setError] = useState();
   const [status, setStatus] = useState(false);
  const {  } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");

  // Extract email, otp, user, and ttr from URL query parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email') || '';
    const otp = params.get('otp') || '';
    const user = params.get('user') || '';
    const ttr = params.get('ttr') || '';

    console.log('OTP:', otp);
    console.log('User:', user);
    console.log('TTR:', ttr);
console.log('eail:', email);
setEmail(params.get('email') || '');
    // Validate ttr (timestamp) if provided
    if (ttr) {
      const expirationTime = ttr;
      if (isNaN(expirationTime) || expirationTime < Date.now()) {
        setError('This link has expired');
        return;
      }
    }

    if (email && otp && user) {
      // Attempt automatic verification
      verifyOtp({ email, otp, user});
      localStorage.setItem('email',email)
    } else {
        setError('Invalid Link')
    }
  }, [location.search]);

  const verifyOtp = async ({email, otp,user }) => {
    console.log(email)
    console.log(otp)
    console.log(user)
    try {
      await axios.post('http://localhost:5009/user/verify', { email, otp, user })
      .then(res => {
        console.log(res.data);
        if(res.data.status === 200){
setError('Thank you. Email verified')
setStatus(true)
setErrors({});
return
        }
        if(res.data.status === 401){
          setError('Email already verified')
          setErrors({ ...errors, server: 'failed' });
          return
                  }
                  if(res.data.status === 400){
                    setError('This link is invalid')
                    setErrors({ ...errors, server: 'failed' });
                    return
                            }
    })
      .catch(err => console.log(err))
    //   setError('');
    //   navigate('/login');
    } catch (error) {
      const message = error.response?.data?.message || 'OTP verification failed';
      setErrors({ ...errors, server: 'failed' });
      setError(message);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.otp.trim()) newErrors.otp = 'OTP is required';
    else if (formData.otp.length < 6) newErrors.otp = 'OTP must be at least 6 characters';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    await verifyOtp(formData);
  };

  console.log(errors.server)
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">{!errors.server && 'Email Verification'}</h2>
        <p className="text-center text-xl text-gray-600 mb-4">
         {status && <>{email} has been verified. Thank You.<div className="flex justify-center mt-[25px]"><button onClick={e => navigate('/')} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Login</button></div></>}
        </p>
        {!status && <><p className="text-red-500 text-xl mb-4 text-center">{error}</p>
        <div className="flex justify-center"></div></>}
      
      </div>
    </div>
  );
};

export default Verify;